import axios from "../util/payrightAxios";


export function fetchLoanDetail(loanId) {

    return (dispatch, getState) => {
            
        const authToken = getState().auth.authToken == null ? localStorage.getItem('authToken') : getState().auth.authToken ;
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const url = `${apiBaseUrl}/customer/loans/${loanId}`;
        axios.defaults.headers.common['auth-token'] = authToken

        dispatch(fetchLoanDetailBegin());
        return axios({ 
            url: url,
            method:"get",
            
        })
        .then(response => {
            dispatch(fetchLoanDetailSuccess(response.data.data.loan));
            return response.data.data.loan;
        })
        .catch(error => {
            dispatch(fetchLoanDetailFaliure(error));
       });

    }
}

export const FETCH_LOANDETAIL_BEGIN = "FETCH_LOANDETAIL_BEGIN";
export const FETCH_LOANDETAIL_SUCCESS = "FETCH_LOANDETAIL_SUCCESS";
export const FETCH_LOANDETAIL_FALIURE = "FETCH_LOANDETAIL_FALIURE";

export const fetchLoanDetailBegin = () => ({
    type: FETCH_LOANDETAIL_BEGIN
});

export const fetchLoanDetailSuccess = loanDetail => ({
   type: FETCH_LOANDETAIL_SUCCESS,
   payload: {loanDetail}
});

export const fetchLoanDetailFaliure = error => ({
    type: FETCH_LOANDETAIL_FALIURE,
    payload: {error},
});